import React, { useContext, useState, useEffect } from "react";
import endpoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import { ListItemSecondaryAction, Grid } from "@mui/material";
import MainCard from "ui-component/cards/MainCard";
import Steeper from "components/Steps/Steeper";
import {
  stepsSolicitudCredito,
  procesoOK,
  procesoWarning,
  procesoError,
} from "utils/Constantes";
import { useNavigate } from "react-router-dom";
import SubCard from "ui-component/cards/SubCard";
import TextFieldInput from "components/input/TextFieldInput";
import InputFieldSelect from "components/inputSelect/InputFieldSelect";
import { DatosGarantes, VerificaDatosGarante } from "utils/types";
import Button from "@mui/material/Button";
import { gridSpacing } from "store/constant";
import { isObjEmpty, fechaFormat } from "utils/utils";
import Table from "components/Tabla/Table";
import { getCodigoUsuario, getCodigoIfip } from "utils/Common";
import FeatherIcon from "feather-icons-react";
import { usePersona } from "../../context/persona";

// Listas
const listaTipoGarantes = [
  {
    codigo: 1,
    nombre: "Garante 1",
  },
  {
    codigo: 2,
    nombre: "Garante 2",
  },
];

const listaGarantesSolicitudCredito = [
  {
    identificacion: "0104786543",
    nombreGarante: "Juan Alava",
    tipoGarante: "Garante Uno",
    fechaCreacion: Date.now(),
  },
  {
    identificacion: "0105487643",
    nombreGarante: "Claudio Vallejo",
    tipoGarante: "Garante Dos",
    fechaCreacion: Date.now(),
  },
];

const Garantes = () => {
  const { infoPersona, setInfoPersona } = usePersona();
  const navigate = useNavigate();
  // HOOKS DE ESTADO NOTIFICACIONES
  const [openNotificacion, setOpenNotificacion] = useState(false);
  const [visualizaMensaje, setVisualizaMensaje] = useState("");
  const [colorNotificacion, setColorNotificacion] = useState("");

  // HOOKS COMUN
  const operacionCredito = infoPersona.codigo; //infoCredito.codigoOperacion
  const [existeGarantia, setExisteGarantia] = useState(false);
  const [datosGarantia, setDatosGarantia] = useState(DatosGarantes());
  const [listGarantias, setListGarantias] = useState([]);

  // const [listaTipoGrantes, setListaTipoGarantes] = useState([])
  const [openTipoGarantes, setOpenTipoGarantes] = useState(false);
  const [objTipoGarante, setObjTipoGarante] = useState({});

  const [numeriIdentificacion, setNumeriIdentificacion] = useState("");
  const [datosNewGarante, setDatosNewGarante] = useState(
    VerificaDatosGarante()
  );
  // ACCESOS STEPS
  const [stepsActive, setStepsActive] = useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  // USEEFECT
  useEffect(() => {
    if (infoPersona.codigo === "" || infoPersona === undefined) {
      navigate("/home/solicitudCredito");
    } else {
      init();
      // handleSearchGarante()
      handleSearchGarantiaOperacionCrediticia();
    }
  }, []);
  // FUNCIONES NOTIFICACION
  const generarNotificacion = (abrir, mensaje, color) => {
    setOpenNotificacion(abrir);
    setVisualizaMensaje(mensaje);
    if (color === 1) {
      setColorNotificacion(procesoOK);
    }
    if (color === 2) {
      setColorNotificacion(procesoWarning);
    }
    if (color === 3) {
      setColorNotificacion(procesoError);
    }
  };
  const cerrarNotificacion = () => {
    setOpenNotificacion(false);
  };
  //FUNCIONES NEGOCIO
  const init = () => {
    setStepsActive(1);
    setInfoPersona({ row: infoPersona.row, codigo: infoPersona.row.codigo, codigoPersona: infoPersona.row.ingresoPersonaMs.personaMs.codigo, valorSolicitado: infoPersona.row.valorSolicitado, primeraCuota: 1 });
  };
  const limpiaComponentes = () => {
    setNumeriIdentificacion("");
    setDatosNewGarante(VerificaDatosGarante());
  };
  const handleSearchGarantiaOperacionCrediticia = () => {
    try {
      (async () => {
        Api(
          endpoints.consultagarantesOperacionCrediticia +
          "/" +
          operacionCredito,
          "GET",
          null
        )
          .then((response) => {
            if (response.length <= 0) {
              setExisteGarantia(false);
              setListGarantias(response);
              generarNotificacion(true, "No existe registro de garantes.", 2);
            } else {
              setExisteGarantia(true);
              setListGarantias(response);
              generarNotificacion(
                true,
                "Información garantes ya registrado.",
                1
              );
            }
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };
  const handleSave = () => {
    if (isObjEmpty(objTipoGarante)) {
      generarNotificacion(true, "Seleccione un tipo de garante valido.", 3);
      return;
    }
    if (
      datosGarantia.numeroGarante === undefined ||
      datosGarantia.numeroGarante === 0
    ) {
      generarNotificacion(true, "Ingrese un número de garantes valido.", 3);
      return;
    }
    if (
      datosGarantia.observacion === undefined ||
      datosGarantia.observacion === ""
    ) {
      generarNotificacion(true, "Ingrese una observación valida.", 3);
      return;
    }
    try {
      (async () => {
        const garantiaOperacionCreMs = {
          codigo: 0,
          codigoEntidad: getCodigoIfip(),
          codigoAgencia: 1,
          operacionCrediticiaMs: {
            codigo: operacionCredito,
          },

          personaMs: {
            codigo: datosNewGarante.codigo,
          },
          numeroGarante: datosGarantia.numeroGarante,
          tipoGarante: objTipoGarante.codigo,
          estado: 1,
          observacion: datosGarantia.observacion,
          fechaRegistra: null,
          codigoUsuarioRegistra: getCodigoUsuario(),
          codigoSocioGarante: datosNewGarante.codigo,
        };
        Api(endpoints.saveGarantes, "POST", garantiaOperacionCreMs)
          .then((response) => {
            if (response.length <= 0) {
              setExisteGarantia(false);
              generarNotificacion(true, "Error en registro de garantes.", 3);
              return;
            } else {
              setListGarantias(response);
              setExisteGarantia(true);
              limpiaComponentes();
              generarNotificacion(true, "Garantes registrados con exito.", 1);
            }
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };
  // OBTIENE INFORMACION DE GARANTES
  const handleSearchGarante = () => {
    console.log("ingresar on blir");
    if (numeriIdentificacion.length !== 10) {
      return generarNotificacion(
        true,
        "El número de identificación debe tener 10 dígitos.",
        3
      );
    }
    try {
      (async () => {
        Api(
          endpoints.obtienePersonaIdentificacion + "/" + numeriIdentificacion,
          "GET",
          null
        )
          .then((response) => {
            if (response.codigo === 0) {
              generarNotificacion(
                true,
                "No existe el socio de acuerdo al numero de identificacion ingresado",
                2
              );
              return;
            } else {
              generarNotificacion(true, "Consulta datos exitoso", 1);
              setDatosNewGarante(response);
            }
          })
          .catch((error) => {
            generarNotificacion(true, error.message, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.message, 3);
    }
  };

  // VALIDACIONES

  // VISTA
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const nextStep = () => {
    navigate("/home/flujos");
  };
  const backStep = () => {

    navigate("/home/solicitudCredito");
  };
  const handleReset = () => {
    let newSkipped = skipped;
    if (isStepSkipped(stepsActive)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(stepsActive);
    }

    setStepsActive((prevActiveStep) => prevActiveStep - 1);
    setSkipped(newSkipped);
  };
  const onChangeIdentificacion = (identificacion) => {
    if (identificacion === undefined) return;
    setNumeriIdentificacion(identificacion);
  };
  // CAMBIOS SELECT
  const onchangeTipoGarante = (event, value) => {
    console.log(value);
    if (value === null) return;
    setObjTipoGarante(value);
  };
  // DATOS PARA TABLA
  const columns = [
    {
      field: "personaMs.numeroIdentificacion",
      title: "Identificación Garante",
      width: 90,
    },
    {
      field: "personaMs.nombres",
      title: "Nombres Garante",
      width: 90,
      editable: "never",
    },
    {
      field: "tipoGarante",
      title: "Tipo Garante",
      width: 150,
    },
    {
      field: "fechaRegistra",
      render: (rowData) => <p>{fechaFormat(rowData.fechaRegistra)}</p>,
      title: "Fecha creación",
      width: 150,
      editable: "never",
    },
  ];
  const newRegistro = (newData) => {
    console.log("Datos a guardar");
    console.log(newData);
  };
  const tamanoCaja = 12;
  const varianField = "outlined";
  return (
    <>
      <Steeper steps={stepsSolicitudCredito} activeStep={stepsActive} />
      <MainCard
        title="Garantes"
        open={openNotificacion}
        mensajeVizualizar={visualizaMensaje}
        colorProceso={colorNotificacion}
        handleClose={() => cerrarNotificacion()}
        secondary={
          <ListItemSecondaryAction link="https://next.material-ui.com/system/typography/" />
        }
      >
        <Grid container xs={12} spacing={gridSpacing}>
          <Grid item xs={12}>
            <SubCard
              style={{ alignItems: "center" }}
              title="REGISTRO DATOS DE GARANTES"
            >
              <Grid container xs={12} spacing={gridSpacing}>
                <Grid item xs={12} sm={12}>
                  <TextFieldInput
                    label={"Número de Identificación"}
                    sm={12}
                    fullWidth
                    varianField={varianField}
                    value={numeriIdentificacion}
                    onBlur={handleSearchGarante}
                    onChange={(e) => {
                      const valor = e.target.value;
                      if (valor.length === 11) {
                        return false;
                      }
                      onChangeIdentificacion(valor);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextFieldInput
                    label={"Nombres Garante"}
                    sm={tamanoCaja}
                    fullWidth
                    varianField={varianField}
                    disabled={false}
                    value={datosNewGarante.nombres}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <InputFieldSelect
                    id={"idTipoGarante"}
                    sm={12}
                    fullWidth
                    variant={"outlined"}
                    label={"Tipo Garante"}
                    loading={false}
                    open={openTipoGarantes}
                    onOpen={() => {
                      setOpenTipoGarantes(true);
                    }}
                    onClose={() => {
                      setOpenTipoGarantes(false);
                    }}
                    options={listaTipoGarantes}
                    getOptionLabel={(option) => option.nombre}
                    value={objTipoGarante || objTipoGarante.codigo}
                    onChange={onchangeTipoGarante}
                  />
                </Grid>
                <Grid item md={12}>
                  <TextFieldInput
                    label={"Observacion"}
                    sm={12}
                    fullWidth
                    varianField={varianField}
                    value={datosGarantia.observacion}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setDatosGarantia((prevState) => {
                        return { ...prevState, observacion: valor };
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div style={{ width: "100%" }}>
                    <Table
                      title="Datos de garantes"
                      columns={columns}
                      data={listGarantias}
                      editable={{
                        onRowAdd: (newData) =>
                          new Promise((resolve, reject) => {
                            setTimeout(() => {
                              newRegistro(newData);
                              resolve();
                            }, 1000);
                          })
                      }}
                    ></Table>
                  </div>
                </Grid>
              </Grid>
            </SubCard>
          </Grid>
        </Grid>
        <br />
        <div className="steps-action">
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={true}
            onClick={handleSave}
          >
            <FeatherIcon icon="save" size={16} /> &nbsp; Guardar
          </Button>
          {existeGarantia && (
            <>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={nextStep}
              >
                <FeatherIcon icon="chevrons-right" size={16} /> &nbsp; Siguiente
              </Button>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={backStep}
              >
                <FeatherIcon icon="chevrons-left" size={16} /> &nbsp; Regresar
              </Button>
            </>
          )}
        </div>
      </MainCard>
    </>
  );
};
export default Garantes;
